module.exports = "\n<!--<pre>{{lastLayoutLength|json}}</pre>\n<pre>{{layout.length|json}}</pre>-->\n<!--<pre>{{breakpoint|json}}</pre>\n<pre>{{layouts|json}}</pre>-->\n<!--<pre>{{layout|json}}</pre>-->\n<!--<pre>width: {{width | json}}</pre>\n<pre>mergedStyle: {{mergedStyle | json}}</pre>-->\n<div v-el:item class=\"vue-grid-layout\" :style=\"mergedStyle\">\n    <slot></slot>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ResponsiveGridLayout.vue
 ** module id = 72
 ** module chunks = 0
 **/